// Chilean regions & comunas (subset, main cities)
export const REGIONES = [
  { value: "rm", label: "Región Metropolitana" },
  { value: "v", label: "Valparaíso" },
  { value: "viii", label: "Biobío" },
  { value: "ix", label: "La Araucanía" },
  { value: "x", label: "Los Lagos" },
  { value: "iv", label: "Coquimbo" },
  { value: "vi", label: "O'Higgins" },
  { value: "vii", label: "Maule" },
  { value: "ii", label: "Antofagasta" },
  { value: "other", label: "Otra región" },
];

export const COMUNAS_BY_REGION = {
  rm: [
    "Las Condes","Vitacura","Providencia","Ñuñoa","Santiago","Lo Barnechea",
    "La Reina","Macul","Peñalolén","San Miguel","La Florida","Maipú","Huechuraba",
    "Independencia","Recoleta","Quilicura","Puente Alto","San Bernardo","Colina",
  ],
  v: ["Viña del Mar","Valparaíso","Concón","Reñaca","Quilpué","Villa Alemana"],
  viii: ["Concepción","Talcahuano","Chiguayante","San Pedro de la Paz","Hualpén"],
  ix: ["Temuco","Padre Las Casas","Villarrica","Pucón"],
  x: ["Puerto Montt","Puerto Varas","Osorno"],
  iv: ["La Serena","Coquimbo","Ovalle"],
  vi: ["Rancagua","Machalí","San Fernando"],
  vii: ["Talca","Curicó","Linares"],
  ii: ["Antofagasta","Calama","Mejillones"],
  other: ["Otra comuna"],
};

export const TIPOS_COMUNIDAD = [
  { value: "edificio", label: "Edificio residencial", desc: "Departamentos con áreas comunes, ascensores y estacionamientos.", icon: "🏢" },
  { value: "condominio_casas", label: "Condominio de casas", desc: "Casas en conjunto con portería, áreas verdes y accesos controlados.", icon: "🏘️" },
  { value: "mixto", label: "Edificio mixto", desc: "Comercio y residencia combinados en un mismo conjunto.", icon: "🏬" },
  { value: "otro", label: "Otro", desc: "Bodegas, estacionamientos, locales u otro tipo de comunidad.", icon: "🏗️" },
];

export const ANTIGUEDADES = [
  "Menos de 5 años",
  "5 – 10 años",
  "10 – 20 años",
  "20 – 30 años",
  "30 – 40 años",
  "Más de 40 años",
];

export const COMPANIAS = [
  "BCI Seguros","Chubb","Consorcio","HDI Seguros","Liberty","Mapfre","Renta Nacional","Zurich","Otra",
];

export const PRODUCTOS_RESIDENTE = [
  { value: "hogar", label: "Hogar", desc: "Contenido + continente para tu departamento o casa.", icon: "🏠" },
  { value: "auto", label: "Auto", desc: "Cobertura modelo flota con precios preferenciales.", icon: "🚗" },
  { value: "garantia_arriendo", label: "Garantía arriendo", desc: "Cubre incumplimiento de pago y servicios básicos.", icon: "🔑" },
  { value: "incendio_hipotecario", label: "Incendio hipotecario", desc: "Reemplaza el seguro bancario con mejor cobertura.", icon: "🔥" },
  { value: "salud", label: "Salud complementario", desc: "Cobertura ambulatoria y hospitalaria adicional.", icon: "❤️" },
  { value: "mascota", label: "Mascota", desc: "Consultas, vacunas y urgencias veterinarias.", icon: "🐾" },
  { value: "viaje", label: "Viaje", desc: "Asistencia médica y equipaje durante tus viajes.", icon: "✈️" },
];

export const TIPOS_SEGURO_B2B = [
  { value: "incendio", label: "Incendio (obligatorio)" },
  { value: "incendio_sismo", label: "Incendio + Sismo" },
  { value: "rc_do", label: "RC Administradores y Comité (D&O)" },
  { value: "os10", label: "Vida OS10 (guardias)" },
  { value: "robo", label: "Robo áreas comunes" },
  { value: "riesgos_naturales", label: "Riesgos naturales" },
  { value: "desempleo_ggcc", label: "Desempleo GGCC" },
];

export const TIPOS_SEGURO_B2C = [
  { value: "hogar", label: "Hogar" },
  { value: "auto", label: "Auto" },
  { value: "garantia_arriendo", label: "Garantía arriendo" },
  { value: "incendio_hipotecario", label: "Incendio hipotecario" },
  { value: "incendio_general", label: "Incendio general" },
  { value: "salud", label: "Salud" },
  { value: "mascota", label: "Mascota" },
  { value: "viaje", label: "Viaje" },
];

export const ESTADOS_COTIZACION = ["nueva", "en_revision", "cotizada", "cerrada"];
export const ESTADOS_POLIZA = ["vigente", "por_vencer", "vencida", "renovada", "anulada"];
export const ESTADOS_CARTA = ["pendiente_firma", "firmada", "archivada"];
